import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {},
});

// Auto-attach token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Only set Content-Type if not FormData
    if (
      config.data &&
      !(config.data instanceof FormData) &&
      !config.headers['Content-Type']
    ) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ prevent multiple redirects on a storm of 401s
let isHandlingAuthError = false;

// Handle expired/invalid tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.msg?.toLowerCase();

    const status = error?.response?.status;
  const hasLocalToken = !!localStorage.getItem('token');
  // cookie auth might exist even if hasLocalToken is false
  // so only hard-logout if:
  // - we had a local token and it’s invalid OR
  // - backend explicitly says token is not valid / verification failed
  const isTokenError =
    message?.includes('token verification failed') ||
    message?.includes('jwt malformed') ||
    message?.includes('invalid token') ||
    message?.includes('token is not valid');

  if (status === 401 && (hasLocalToken || isTokenError)) {
      if (!isHandlingAuthError) {
        isHandlingAuthError = true;

        console.warn('⚠️ Token issue detected — logging out and redirecting to login');

        // ✅ clear auth state
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.setItem('sessionExpired', 'true');

        // ✅ if not already on login, go there with flag
        if (window.location.pathname !== '/') {
          window.location.href = '/?sessionExpired=1';
        }
        // ✅ if already on '/', do nothing here:
        // Login component will read `sessionExpired` from sessionStorage
        // and show the warning without reloading/looping.
      }
    }

    return Promise.reject(error);
  }
);

export default api;
